import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function NaseljeIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="NaseljeIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="currentcolor" d="M23.533,76.9V35.728h17.645v-5.881L50,21.024l8.822,8.823v17.645h17.645V76.9H23.533z M29.415,47.492h5.882
	V41.61h-5.882V47.492z M29.415,59.254h5.882v-5.881h-5.882V59.254z M29.415,71.018h5.882v-5.882h-5.882V71.018z M47.059,35.728
	h5.882v-5.881h-5.882V35.728z M47.059,47.492h5.882V41.61h-5.882V47.492z M47.059,59.254h5.882v-5.881h-5.882V59.254z
	 M47.059,71.018h5.882v-5.882h-5.882V71.018z M64.704,59.254h5.882v-5.881h-5.882V59.254z M64.704,71.018h5.882v-5.882h-5.882
	V71.018z"/>
    </svg>
  </SvgIcon>
}

export default NaseljeIcon;
